import { useEffect } from "react";
import { getStudioAuthUrl } from "@/utilities/studio-auth";

export const useSignoutUser = () => {
  useEffect(() => {
    // Redirect to the auth service to sign out the user, without returning to the app
    window.location.replace(getStudioAuthUrl("/signout", { returnTo: false }));
  }, []);
};
